import React, { useState } from "react";
import "./ModalManager.css";
import toast from "react-hot-toast";
import { ImCancelCircle } from "react-icons/im";

const DeleteMenuModal = ({ item, onClose, onRemove }) => {
  const [deleteLabel, setDeleteLabel] = useState(item.label);
  const [deleteURL, setDeleteURL] = useState(item.url);
  const [slNo, setSlNo] = useState(item.slno);

  const handleDelete = () => {
    const deleteData = {
      slno: slNo,
      label: deleteLabel,
      url: slNo,
    };
    onRemove(deleteData);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <h3 className="modal-title">Delete Menu Link</h3>
          <button className="modal-close-btn" onClick={onClose}>
            <ImCancelCircle />
          </button>
        </div>

        <div className="modal-content">
          <div className="form-group">
            <label className="form-label">Label</label>
            <input
              type="text"
              value={deleteLabel}
              className="form-input"
              readOnly
            />
          </div>
          <div className="form-group">
            <label className="form-label">URL</label>
            <input
              type="text"
              value={deleteURL}
              className="form-input"
              readOnly
            />
          </div>
          <div className="form-group">
            <label className="form-label">Serial Number (SLNO)</label>
            <input type="text" value={slNo} className="form-input" readOnly />
          </div>
        </div>

        <div className="modal-footer">
          <button className="view-btn" onClick={handleDelete}>
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteMenuModal;
